import { isBoolean } from 'lodash-es';

export function toInt(num: any, radix: number = 10) {
	if (isBoolean(num)) {
		return +num;
	}

	const value: number = parseInt(num, radix);
	return Number.isNaN(value) ? 0 : value;
}
